module.exports = __webpack_public_path__ + "img/FamilyShoplogo.931350fc.svg";